/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import { CDN } from '../../../constants';
import { distributorService } from '../../../service/distributor.service';

function ViewandDownloadModal({
    viewandDownloadModal, setViewandDownloadModal, viewInvoiceDetails, setViewInvoiceDetails,
}) {
    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');
    const [billaddresspop, setbilladdresspop] = useState(false);
    const [shipaddresspop, setshipbilladdresspop] = useState(false);

    const handlePresignedURL = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber, true);
        if (!res?.error && res?.data?.url !== null) {
            return res?.data?.url;
        }
        return false;
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${viewandDownloadModal ? '' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="view-and-download" tabIndex="-1" aria-labelledby="virtualPayment" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative md:max-w-[850px] md:min-w-[850px] w-full px-3 mx-auto pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current sm:pt-11 pt-8 pb-6 sm:px-3 px-2 h-auto">
                    <button
                        type="button"
                        className="absolute sm:top-4 sm:right-4 top-2.5 right-2.5"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setViewandDownloadModal(false)}
                    >
                        <img src="/images/Icon-ionic-ios-close.svg" alt="icon" />
                    </button>
                    <div className="pt-5 sm:px-4 px-1">
                        <div className="flex flex-wrap">
                            <div className="w-full">
                                <div className="flex justify-between items-center mb-2">
                                    <div>
                                        <p className="font-semibold text-xs text-[#777777]">Invoice Number</p>
                                        <p className="font-normal text-[#090406] sm:text-xs16 text-base">{viewInvoiceDetails?.TRX_NUMBER}</p>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-xs text-[#777777]">Order Date</p>
                                        <p className="text-[#090406] font-normal text-lg">{viewInvoiceDetails?.ORDER_ACCEPTANCE_DATE}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="flex w-full lg:flex-row flex-col">
                                <div className="flex flex-wrap items-start lg:w-[50%] w-full mb-3 mt-3">
                                    <div className="flex -mx-1 flex-wrap">
                                        <div className="lg:w-[30%] w-[50%] pb-5 px-1">
                                            <p className="text-xs font-semibold text-[#777777]">Invoice Date</p>
                                            <p className="font-normal text-[#090406] sm:text-lg text-sm">{viewInvoiceDetails?.INVOICE_DATE}</p>
                                        </div>
                                        <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                            <p className="text-xs font-semibold text-[#777777]">E-way bill Number</p>
                                            <p className="font-normal text-[#090406] sm:text-lg text-sm">{viewInvoiceDetails?.WAYBILL_NUMBER}</p>
                                        </div>
                                        <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                            <p className="text-xs font-semibold text-[#777777]">Indent Number</p>
                                            <p className="font-normal text-[#090406] sm:text-lg text-sm">{viewInvoiceDetails?.INDENT_NUMBER}</p>
                                        </div>
                                        <div className="lg:w-[30%] w-[50%] pb-5 px-1">
                                            <p className="text-xs font-semibold text-[#777777]">Order Category</p>
                                            <p className="font-normal text-[#090406] sm:text-lg text-sm">{viewInvoiceDetails?.ORDER_CATEGORY}</p>
                                        </div>
                                        <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                            <p className="text-xs font-semibold text-[#777777]">Invoice Value</p>
                                            <p className="font-normal text-[#090406] sm:text-lg text-sm">{PriceHandler(viewInvoiceDetails?.INVOICE_VALUE)}</p>
                                        </div>
                                        <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                            <p className="text-xs font-semibold text-[#777777]">Payment Status</p>
                                            {viewInvoiceDetails?.PAYMENT_STATUS === null
                                                ? <p className="font-normal text-[#090406] sm:text-lg text-sm">-</p>
                                                : <p className="font-normal text-[#090406] sm:text-lg text-sm">{viewInvoiceDetails?.PAYMENT_STATUS}</p>}

                                        </div>
                                        <div className="w-auto pb-5 px-1">
                                            {viewInvoiceDetails?.INVOICE_LINK && viewInvoiceDetails?.INVOICE_LINK !== null && (
                                                <button
                                                    type="button"
                                                    onClick={async () => {
                                                        const url = await handlePresignedURL(viewInvoiceDetails?.INVOICE_NO);
                                                        if (url !== false) {
                                                            window.open(url, '_blank');
                                                        }
                                                    }}
                                                    className="w-full pb-5 px-1 mt-2"
                                                >
                                                    <p className="font-semibold text-[#090406] text-sm14 text-left"><u>View and Download Invoice</u></p>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:w-[50%] w-full bg-[#F5F5FA] rounded-lg px-3 py-2 mb-5 h-auto">
                                    <div className="w-full flex sm:nowrap flex-wrap justify-start px-4 pt-2.5 pb-2 rounded-lg xl:mt-0 mt-3 relative bg-white shadow-s9">
                                        <button onClick={() => setbilladdresspop(!billaddresspop)} type="button" className="pr-2 border-r border-[#CECECE] flex justify-between items-center xl:auto sm:w-1/2 w-full text-left showAddress-full2">
                                            <div className="w-[80%]">
                                                <p className="text-xs font-semibold text-[#808285]">Billing address</p>
                                                <p className="text-xs6 font-semibold text-[#555259] more-lines">{viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.ADDRESS1}</p>
                                            </div>
                                            <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[20%]">View</p>
                                        </button>
                                        {billaddresspop
                                            && (
                                                <div className="absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-10 adderess-show2">
                                                    <div className="flex items-center justify-between">
                                                        <p className="sm:text-xs6 text-sm font-semibold text-[#808285]">Billing address</p>
                                                    </div>
                                                    <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.ADDRESS1}
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.ADDRESS2}
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.ADDRESS3}
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.ADDRESS4}
                                                        ,
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.CITY}
                                                        -
                                                        {`${viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.POSTAL_CODE}`}
                                                        ,
                                                        {' '}
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.STATE}
                                                        ,
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.LOCATION || '-'}
                                                        {viewInvoiceDetails?.details[0]?.BILLING_ADDRESS?.ATTRIBUTE2 || '-'}
                                                    </p>
                                                </div>
                                            )}
                                        <div className="sm:px-2 px-0 xl:auto sm:w-1/2 w-full flex justify-between items-center sm:mt-0 mt-2">
                                            <button onClick={() => { setshipbilladdresspop(!shipaddresspop); }} type="button" className="pr-2 flex justify-between items-center xl:auto w-full text-left showAddress-full2">
                                                <div className="w-[80%]">
                                                    <p className="text-xs font-semibold text-[#808285]">Shipping address</p>
                                                    <p className="text-xs6 font-semibold text-[#555259] more-lines">{viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.ADDRESS1}</p>
                                                </div>
                                                <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[20%]">View</p>
                                            </button>
                                        </div>
                                        {shipaddresspop
                                            && (
                                                <div className="absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-10 adderess-show2 ">
                                                    <div className="flex items-center justify-between">
                                                        <p className="sm:text-xs6 text-sm font-semibold text-[#808285]">Shipping address</p>
                                                    </div>
                                                    <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.ADDRESS1}
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.ADDRESS2}
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.ADDRESS3}
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.ADDRESS4}
                                                        ,
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.CITY}
                                                        -
                                                        {`${viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.POSTAL_CODE}`}
                                                        ,
                                                        {' '}
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.STATE}
                                                        ,
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.LOCATION || '-'}
                                                        {viewInvoiceDetails?.details[0]?.SHIPPING_ADDRESS?.ATTRIBUTE2 || '-'}
                                                    </p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mt-3">
                                        <p className="text-xs font-semibold text-[#777777]">Transporter Name</p>
                                        {viewInvoiceDetails?.TRANSPORTER_NAME === null
                                            ? <p className="text-sm font-normal text-[#090406] mt-[2px]">-</p>
                                            : <p className="text-sm font-normal text-[#090406] mt-[2px]">{viewInvoiceDetails?.TRANSPORTER_NAME}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="border-t border-[#CBCBCB]">
                            <p className="pt-2 pb-3 text-[#090406] font-semibold text-base">Related Documents</p>
                            <div className="flex flex-wrap items-start">
                                {(viewInvoiceDetails?.e_way_bill === null || viewInvoiceDetails?.e_way_bill === '') ? null
                                    : (
                                        <button
                                            className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg E-way-bill mb-3"
                                            onClick={() => {
                                                window.open(`${CDN}/${viewInvoiceDetails?.e_way_bill}`, '_blank');
                                            }}
                                        >
                                            <img src="/images/download.svg" alt="icon" />
                                            <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download E-way Bill</p>
                                        </button>
                                    )}

                                {(viewInvoiceDetails?.lr_copy === null || viewInvoiceDetails?.lr_copy === '') ? null
                                    : (
                                        <button
                                            className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg mx-3 LR-Copy mb-3"
                                            onClick={() => {
                                                window.open(`${CDN}/${viewInvoiceDetails?.lr_copy}`, '_blank');
                                            }}
                                        >
                                            <img src="/images/download.svg" alt="icon" />
                                            <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download LR Copy</p>
                                        </button>
                                    )}

                                {(viewInvoiceDetails?.invoice === null || viewInvoiceDetails?.invoice === '') ? null
                                    : (
                                        <button
                                            className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg Invoice mb-3"
                                            onClick={() => {
                                                window.open(`${CDN}/${viewInvoiceDetails?.invoice}`, '_blank');
                                            }}
                                        >
                                            <img src="/images/download.svg" alt="icon" />
                                            <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download Invoice</p>
                                        </button>
                                    )}

                                {/* {<button className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg ml-3 po-documnent">
                                <img src="/images/download.svg" alt="icon/"/>
                                <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download PO Document</p>
                            </button>} */}
                            </div>

                            <div className="overflow-x-hidden overflow-auto sidebar h-[200px]">
                                {viewInvoiceDetails?.details.map((item, key) => (
                                    <div className="mt-3 mb-5" key={key}>
                                        <div className="border border-[#D9D9D9] rounded-lg p-2.5">
                                            <div className="flex justify-between w-full items-start md:flex-row flex-col">
                                                <div className="mb-3 md:w-[75%] w-full">
                                                    <div className="flex">
                                                        <img src={handleImage(item?.IMAGE_NAME)} alt="image" className="mr-4 w-[40px] h-[40px]" />
                                                        <div className="">
                                                            <p className="text-xs6 font-normal text-[#090406] pr-3 break-words">{item?.MODEL_DESCRIPTION}</p>
                                                            <p className="sm:text-xs3 font-normal text-[#808285] mt-1">
                                                                <span>
                                                                    Product Code:
                                                                    {item?.CONCATENATED_SEGMENTS}
                                                                </span>
                                                                <span className="sm:px-4 px-2">|</span>
                                                                <span>
                                                                    AWS Classification:
                                                                    {item?.AWS_CLASSIFICATION}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p className="font-normal text-xs3 text-[#808285] pt-2.5">{item?.DESCRIPTION}</p>
                                                </div>
                                                <div className="md:w-[25%] w-full mb-3">
                                                    {Object.values(item?.test_certificates).includes(null)
                                                        ? (
                                                            <div>
                                                                <p className="font-semibold text-[#5B5B5B] text-xs3">Machine Serial Number</p>
                                                                {item?.test_certificates && Object.entries(item?.test_certificates).map((test, idx2) => (
                                                                    <p className="font-normal text-[#303030] text-xs3 mt-1.5" key={idx2}>
                                                                        {test[0]}
                                                                        ,
                                                                        {' '}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        )
                                                        : (
                                                            <div>
                                                                <p className="font-semibold text-[#5B5B5B] text-xs3">View and Download Test Certificate(s)</p>
                                                                {item?.test_certificates && Object.entries(item?.test_certificates).map((test, idx1) => (
                                                                    <a target="_blank" rel="noreferrer" className="font-normal underline text-[#303030] text-xs3 mt-1.5 cursor-pointer" href={test[1]} key={idx1}>
                                                                        {test[0]}
                                                                        ,
                                                                        {' '}
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                            <div className="flex flex-wrap items-center md:w-[60%] w-full">
                                                <div className="md:w-1/4 w-1/2">
                                                    <p className="font-semibold text-[#808285] text-xs3">List Price</p>
                                                    <p className="font-semibold text-[#15090E] text-xs9">{PriceHandler(item?.LIST_PRICE)}</p>
                                                </div>
                                                <div className="md:w-1/4 w-1/2">
                                                    <p className="font-semibold text-[#808285] text-xs3">Quantity</p>
                                                    <p className="font-semibold text-[#15090E] text-xs9">
                                                        {item?.INVOICED_QUANTITY}
                                                        {' '}
                                                        {item?.PRIMARY_UOM_CODE || 'Kg'}
                                                    </p>
                                                </div>
                                                <div className="md:w-1/4 w-1/2">
                                                    <p className="font-semibold text-[#808285] text-xs3">GST</p>
                                                    <p className="font-semibold text-[#15090E] text-xs9">{PriceHandler(item?.GST_TAXES || 0)}</p>
                                                </div>
                                                <div className="md:w-1/4 w-1/2">
                                                    <p className="font-semibold text-[#808285] text-xs3">Gross Amount </p>
                                                    <p className="font-semibold text-[#15090E] text-xs9">{PriceHandler(item.LINE_TOTAL_AMOUNT)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewandDownloadModal;
